import { useState, useEffect } from "react";
import Pagination from "./Pagination";
import Select from "react-select";
import { Preloader } from "./Preloader";
import { ShowingResults } from "./ShowingResult";

const PROVIDER_ID = 13;

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export const CourseFormCard = (props) => {
  const [currentCoursePage, setCurrentCoursePage] = useState(1);
  const [totalCourses, setTotalCourses] = useState(10);
  const [isLoading, setIsLoading] = useState(true);
  const [searchResults, setSearchResults] = useState([]);
  const selectedObject = props.data.courseType?.find(item => item.Description === props.deliveryTime) || { Id: 0, Description: "All" };
  const selectedLocationObj = props.data.areaList?.find(item => item.Id === parseInt(props.selectedLocation)) || { Id: 0, Description: "All" };
  // console.log(selectedObject);
  // console.log(selectedLocationObj);
  //   const selectedObject = (props.data.courseType || []).find(
  //     (item) => item.Code === props.deliveryTime
  //   ) || { Id: 0, Description: "All" };

  // console.log(props.data.courseType);
  // console.log(props.data)
  const [formValues, setFormValues] = useState({
    keyword: props.inputSearch || "",
    courseType: {
      value: selectedObject.Id,
      label: selectedObject.Description,
    },
    location: {
      value: selectedLocationObj.Id,
      label: selectedLocationObj.Description,
    },
    interestArea: props.interestArea.map((area) => ({
      value: area.Id,
      label: area.Description,
    })),
  });
  const search = useDebounce(formValues.keyword, 1000);
  const handleFormChange = (field, value) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      [field]: value,
    }));
  };




  const pageSize = 10;
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const iscedIdsString = formValues.interestArea
        .map((item) => item.value)
        .join(",");

      const requestData = {
        ISCEDIds: iscedIdsString || 0,
        ProviderIds: PROVIDER_ID,
        Keywords: formValues.keyword,
        LocationIds: Number(formValues.location.value),
        DeliveryModeId: formValues.courseType?.value || 0,
      };
      // console.log(requestData);
      try {
        const response = await fetch(
          `https://service.fetchcourses.ie/service/fetchcourse.svc/json/SearchCourseListSummaryAdvanced/${currentCoursePage}/${pageSize}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );

        const data = await response.json();
        // Fetch the DurationWeeks for each course concurrently
        const coursesWithDurationPromises = data.SearchCourseListSummaryAdvancedResult.courses.map(
          async (course) => {
            const courseId = course.CourseId;
            const durationResponse = await fetch(
              `https://service.fetchcourses.ie/service/fetchcourse.svc/json/GetIndividualCourseDetail/${courseId}/0`
            );
            const durationData = await durationResponse.json();
            const durationWeeks = durationData.DurationWeeks;
            // Return a new object with the additional 'DurationWeeks' property
            return {
              ...course,
              DurationWeeks: durationWeeks,
            };
          }
        );

        const coursesWithDuration = await Promise.all(
          coursesWithDurationPromises
        );
        setTotalCourses(
          data.SearchCourseListSummaryAdvancedResult.totalCourses
        );
        setSearchResults(coursesWithDuration);
      } catch (error) {
        console.error("Error:", error);
      }
      setIsLoading(false);
    };

    fetchData();
  }, [formValues, currentCoursePage]);

  const handleCoursePageChange = (pageNumber) => {
    setCurrentCoursePage(pageNumber);
  };

  return (
    <div>
      <div className="course-form box-shadow">
        <div className="input-wrapper">
          <input
            type="text"
            placeholder="Search course..."
            value={formValues.keyword}
            name="keyword"
            onChange={(e) => handleFormChange("keyword", e.target.value)}
          />
          {/* <span className="text-primary text-bold">Find Course</span> */}
        </div>
        <hr className="form-element-separator" />
        <div>
          <label>Filters</label>
          <div className="select-wrapper">
            <Select
              className="course-form-select"
              classNamePrefix="react-select"
              defaultValue={formValues.courseType}
              onChange={(selectedOption) =>
                handleFormChange("courseType", selectedOption)
              }
              options={props.data.courseType.map((type) => {
                let formattedDescription = type.Description;
                if (
                  formattedDescription === "Fulltime" ||
                  formattedDescription === "Parttime"
                ) {
                  formattedDescription =
                    formattedDescription.slice(0, -4) +
                    "-" +
                    formattedDescription.slice(-4);
                }
                return {
                  label: formattedDescription,
                  value: type.Id,
                };
              })}
            />
            <Select
              className="course-form-select"
              classNamePrefix="react-select"
              name="location"
              defaultValue={formValues.location}
              onChange={(selectedOption) =>
                handleFormChange("location", selectedOption)
              }
              options={props.data.areaList.map((loc) => ({
                value: loc.Id,
                label: loc.Description,
              }))}
            />
            <Select
              className="course-form-select select-interest"
              classNamePrefix="react-select"
              isMulti
              options={props.data.interestArea.map((area) => ({
                value: area.Id,
                label: area.Description,
              }))}
              defaultValue={props.interestArea.map((area) => ({
                value: area.Id,
                label: area.Description,
              }))}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  flex: 1,
                }),
              }}
              onChange={(selectedOptions) =>
                handleFormChange(
                  "interestArea",
                  selectedOptions.map((option) => option)
                )
              }
            // value={selectedOption}
            // onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div style={{ margin: "3rem 0" }}>
        {isLoading ? (
          <Preloader />
        ) : (
          <div>
            <div>
              <h4 style={{ marginBottom: 0 }}>Showing results</h4>
              <span>{searchResults.length} courses</span>
            </div>
            <div className="course-list">
              {searchResults.map((searchValue) => (
                <ShowingResults
                  searchValue={searchValue}
                  key={searchValue.id}
                />
              ))}
            </div>
            <Pagination
              currentCoursePage={currentCoursePage}
              totalCourses={totalCourses}
              pageSize={pageSize}
              onPageChange={handleCoursePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};
